import { Component, OnInit } from '@angular/core';
import { component, ICountDown, IData, ILayoutSettings, IPageContent, ISocialLinks } from '@app/feature/store-editor/components/layout/store-editor.interface';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { StoreService } from '@app/feature/store-admin/services/store.service';
import { ActivatedRoute } from '@angular/router';
import IStoreGetDetailsInterface = namespace.IStoreGetDetailsInterface;
import { NotificationService } from '@app/core/services/notification/notification.service';
import { GetStoreInterface } from '@app/shared/services/common/getStoreList.interface';
import { APIResponse } from '@app/shared/services/core/ICore.interface';
import { LoaderService } from '../../../../core/services/loader/loader.service';
import { debounceTime } from 'rxjs/operators';
import * as introJs from 'intro.js/intro.js';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
  layoutSettings: ILayoutSettings = {
    maxWidth: 1224,
    color: '#1fb999',
    header: {
      logo: '/assets/img/Merch-Loop4.png',
      bgColor: 'rgb(255 255 255)',
      colorLink: '#1fb999',
      paddingOnSides: 10,
      IsDefaultLogo: true
    },
    footer: {
      logo: '/assets/img/Merch-Loop4.png',
      bgColor: 'rgb(255 255 255)',
      colorLink: '#1fb999',
      paddingOnSides: 10,
      IsDefaultLogo: true
    }
  };
  displaySetting: component = 'PAGE';
  displayListComponent = false;
  itemIndexSelected: number | null = null;
  pageContent: IPageContent[] = [
  ];
  socialLinks: ISocialLinks;
  editStoreId: string;
  storeName: string;
  viewOnly = true;
  IsSuperAdmin = false;
  constructor(private storeService: StoreService,
    private activatedRoute: ActivatedRoute,
    private notificationService: NotificationService, private loaderService: LoaderService) {

    this.activatedRoute.params.subscribe(params => this.editStoreId = params.id);
    this.IsSuperAdmin = localStorage.getItem('role') === 'SuperAdmin';
    this.activatedRoute.data.subscribe(data => {
      this.viewOnly = data.viewOnly;
    });
  }

  ngOnInit() {
    this.getDesignSetting();
  }

  coder() {
    return {
      decode: function (data: string): { layoutSettings: any, pageContent: any } {
        try {
          return JSON.parse(data);
        } catch (e) {
          return null;
        }
      },
      encoder: function (layoutSettings: any, pageContent: any) {
        return JSON.stringify({ layoutSettings, pageContent });
      }
    };
  }

  getDesignSetting() {
    this.storeService.getStoreById(this.editStoreId).subscribe((res) => {
      this.storeName = res.Data.ResponseData.StoreUrl;
      this.getDesign(res);
      this.getSocialLinks(res);
    });
  }

  getDesign(res: APIResponse<GetStoreInterface>) {
    const design = this.coder().decode(res.Data.ResponseData.DesignSetting);
    if (design) {
      this.layoutSettings = design.layoutSettings;
      if (typeof this.layoutSettings.maxWidth !== 'number') {
        this.layoutSettings.maxWidth = 1224;
      }
      this.pageContent = design.pageContent;

      if (!this.viewOnly) {       
        if (res.Data.IsFirstTimeStoreVisitor) {
          //show intro only if it editor mode
          var introProfile = introJs();
          introProfile.onafterchange(function (targetElement) {
            switch (targetElement.id) {
              case "editPropPanel":
                setTimeout(function () {
                  $('.introjs-tooltip').css({ top: '25px' });
                  $('.introjs-helperNumberLayer').css({ top: '15px', left: '10px' });
                  $('.introjs-tooltipReferenceLayer').css({ top: '-5px', left: '-5px' });
                  $('.introjs-helperLayer').css({ top: '-5px', left: '-5px' });
                }, 600);

            }
          });
          introProfile.start();
        } else {
          this.notificationService.info('Keep saving your work to prevent loss of design!', 'Reminder!!!');

        }
      }
    }
  }

  getSocialLinks(res: APIResponse<GetStoreInterface>) {
    if (res.Data.ResponseData.StoreSocialMedia! = null) {
      this.socialLinks = {
        YouTubeUrl: res.Data.ResponseData.StoreSocialMedia.YouTubeUrl,
        FacebookUrl: res.Data.ResponseData.StoreSocialMedia.FacebookUrl,
        TwitterUrl: res.Data.ResponseData.StoreSocialMedia.TwitterUrl,
        InstagramUrl: res.Data.ResponseData.StoreSocialMedia.InstagramUrl,
      };
    } else {
      this.socialLinks = {
        YouTubeUrl: '',
        FacebookUrl: '',
        TwitterUrl: '',
        InstagramUrl: '',
      };
    }
  }

  updateDesignSetting() {
    this.loaderService.show()
    this.storeService.updateStoreDesign({ StoreId: Number(this.editStoreId), DesignSetting: this.coder().encoder(this.layoutSettings, this.pageContent) })
      .subscribe((res) => {
        this.loaderService.hide();
        if (res.StatusCode == 401)
          this.notificationService.info(res.Message, 'Store');
        else if (res.StatusCode == 500)
          this.notificationService.error('Error occured, Please try again later!', 'Store');
        else
          this.notificationService.success('Updated Sucessfully', 'Store');
      });
  }

  addItemFeaturedProducts(): IData {
    return {
      bgColor: '#fff',
      textColor: '#000',
      header: 'Featured Products',
      description: 'This is where you can highlight specific products on the homepage of your store. Feel free to change them out frequently.',
      products: [{
        price: '20.00',
        desc: '100% Cotton Ladies Tshirt',
        name: 'Ladies Tshirt',
        image: 'https://cdn.inksoft.com/images/products/1664/products/6004/WHITE/front/versions/001/500.png',
        DesignId: -1,
        ProductId: 0
      }, {
        price: '20.00',
        desc: '60/40 Blended Unisex Tshirt',
        name: 'Unisex Tshirt',
        image: 'https://cdn.inksoft.com/images/products/2728/products/N6210/MIDNIGHT_NAVY/front/versions/003/500.png',
        DesignId: -1,
        ProductId: 0
      }],
    };
  }

  addItemSlider(): IData {
    return {
      images: [
       
        {
          active: true,
          image: '/assets/img/slider2.jpg',
          translateX: 0,

        },
        {
          active: true,
          image: '/assets/img/slider3.jpg',
          translateX: 0,

        }, {
          active: true,
          image: '/assets/img/slider1.jpg',
          translateX: 0,

        },
      ],
      Heading: '',
      SubHeading: ''

    };
  }


  addItemCTA(): IData {
    return {
      bgColor: '#fff',
      textColor: '#000',
      bgImage: '',
      paddingTopAndBottom: 10,
      Buttonlink: [{
        link: "#Link",
        text: "Text on Button",
        colorLink: ""
      }],
      description: `Call to Actions are great to get customers to navigate to specific pages or outside links. Go ahead and give it a try by updating this text and the URL for links`,
      header: 'Call To Action',
      textAlign: 'LEFT'
    };
  }

  countDown(time: number): ICountDown {
    const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;

    const countDown = new Date(time).getTime();

    const now = new Date().getTime(),
      distance = countDown - now;

    return {
      day: Math.floor(distance / (day)),
      hour: Math.floor((distance % (day)) / (hour)),
      min: Math.floor((distance % (hour)) / (minute)),
      sec: Math.floor((distance % (minute)) / second)
    };
  }
  addItemCountDown(): IData {
    const time = new Date().getTime() + 24 * 60 * 60 * 1000;
    return {
      bgColor: '#fff',
      textColor: '#000',
      bgImage: '',
      description: `The countdown timer gives you the ability to create a timed store and close the store automatically.
       This helps in fundraising campaigns and creating a sense of urgency for your customers.
        From the edit options, you can choose what you would like your store to read once its closed,
         as well as if you would like to close the store. Stores can always be reopened again by opening the store in the edit options.`,
      header: 'CountDown',
      time: time,
      countdown: {
        day: this.countDown(time).day,
        hour: this.countDown(time).hour,
        min: this.countDown(time).min,
        sec: this.countDown(time).sec,
      }
    };
  }


  addItemAlert(): IData {
    return {
      bgColor: '#fff',
      textColor: '#000',
      description: 'Alerts are great for sending a message quick and easy. Put up an alert to the top of your page for users to see this message first.',
    };
  }

  addItemTestimonial(): IData {
    return {
      bgColor: '#fff',
      textColor: '#000',
      description: 'This is where you can describe how much your customers rock',
      header: 'Customer',
      list: [
        {
          image: '',
          name: 'User',
          text: 'Loved the quality of the products'
        }
      ]
    };
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.pageContent, event.previousIndex, event.currentIndex);
    if (event.previousIndex === this.itemIndexSelected) {
      this.itemIndexSelected = event.currentIndex;
    }
  }

  addItem(item: component) {
    let data: IData = {};
    switch (item) {
      case 'CTA':
        data = this.addItemCTA();
        break;
      case 'COUNTDOWN':
        data = this.addItemCountDown();
        break;
      case 'SLIDER':
        data = this.addItemSlider();
        break;
      case 'TESTIMONIAL':
        data = this.addItemTestimonial();
        break;
      case 'ALERT':
        data = this.addItemAlert();
        break;
      case 'FEATURED-PRODUCTS':
        data = this.addItemFeaturedProducts();
        break;
      case 'TEXT':
        data = {
          description: `This is a text block. Feel free to free type into this box. Use the paragraph editor to change text format, add images or video, and more.`
        };
        break;
      case 'VIDEO':
        data = {
          link: '2_lu0bfwNd0',
          playerSetting:
          {
            autoplay: false,
            color: 'red',
            controls: true,
            loop: false,
            modestbranding: true,
            height: 360
          }
        };
        break;
    }
    this.pageContent.push(
      {
        type: item,
        style: 'pe-co-pg-block',
        data: data
      });

    this.displayListComponent = false;
  }

  selectItem(indexItem: number, itemType: component) {
    this.itemIndexSelected = indexItem;
    this.displaySetting = itemType;
  }

  removeItem(indexItem: number) {
    this.pageContent.splice(indexItem, 1);
  }


}
